import React from "react";

import PageContent from "2g-page-content";
import { useAuthProvider } from "2g-auth";

import RezervaceWidgetNejblizsi from "b2b/components/rezervace-widget/RezervaceWidgetNejblizsi";
import RezervaceVytvoreniRychlaWidget from "b2b/components/rezervace-vytvoreni/RezervaceVytvoreniRychlaWidget";
import ProvozniInformacePosledniWidget from "b2b/components/provozni-informace-posledni-widget/ProvozniInformacePosledniWidget";
import ZadostiOdbaveniWidget from "b2b/components/zadosti-odbaveni-widget/ZadostiOdbaveniWidget";
import ZadostiOdsouhlaseneWidget from "b2b/components/zadosti-odsouhlasene-widget/ZadostiOdsouhlaseneWidget";
import FixniPozadavkyBox from "b2b/components/fixni-pozadavky-box/FixniPozadavkyBox";
import FixniNarokyNasledujiciWidget from "b2b/components/fixni-naroky-nasledujici/FixniNarokyNasledujiciWidget";

function Prehled() {
  const { userInfo, zakaznik } = useAuthProvider();
  return (
    <PageContent>
      <div className="b2b-Prehled">
        {userInfo.isUserInRole(["admin", "vuz_spravce", "vuz_edit"]) ? (
          <div className="b2b-PrehledRow">
            <ZadostiOdbaveniWidget />
            <div className="b2b-PrehledColumn">
              <FixniPozadavkyBox />
              <RezervaceVytvoreniRychlaWidget />
            </div>
          </div>
        ) : (
          <div className="b2b-PrehledRow">
            <RezervaceVytvoreniRychlaWidget />
            <div className="b2b-PrehledColumn">
              <FixniPozadavkyBox />
              <FixniNarokyNasledujiciWidget ico={zakaznik.ico} />
            </div>
          </div>
        )}

        <ZadostiOdsouhlaseneWidget />
        <RezervaceWidgetNejblizsi />
        <ProvozniInformacePosledniWidget />
      </div>
    </PageContent>
  );
}

export default React.memo(Prehled);
